export class UnitDisplayUpdater {
  constructor(i18n) {
    this.i18n = i18n || {
      metric: 'Change units to Metric',
      imperial: 'Change units to Imperial'
    }
  }

  isJapanese(text) {
    // Matches Japanese characters: Kanji, Hiragana, Katakana
    // Same pattern as Ruby helper: /[一-龯ぁ-んァ-ン]/
    return /[\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF]/.test(text)
  }

  updateDisplays(elements, targetUnit) {
    elements.forEach(element => {
      const newText = targetUnit === 'imperial' 
        ? element.dataset.imperial 
        : element.dataset.metric
      
      // Preserve the nested span structure with lang attribute
      if (this.isJapanese(newText)) {
        element.innerHTML = `<span lang="ja-jp" class="">${newText}</span>`
      } else {
        element.textContent = newText
      }
    })
  }

  updateLabels(labels, targetUnit) {
    const newLabel = this.i18n[targetUnit]
    
    labels.forEach(label => {
      label.innerHTML = newLabel
    })
  }
}
